import React from 'react'
import NavBar from './NavBar'

function About() {
  return (
    <>
    <NavBar />
    <section className="hero-section">
      <p>Welcome to </p>
      <h1 style={{color:"#235784"}}>About Page</h1>
    </section>
  </>
  )
}


export default About

